module.exports = __webpack_public_path__ + "img/img-permission.f58492b2.png";